import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Grid2,
  Typography,
  Divider,
  IconButton,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Modal,
  TextField,
  Rating,
  Snackbar,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router";
import PackageListings from "../../utils/services/PackageListing.api";
import copy from "../../assets/copy.svg";
import edit from "../../assets/edit-05.svg";
import deleteIcon from "../../assets/delete.svg";
import sender from "../../assets/senduser.svg";
import receiver from "../../assets/receiver.svg";
import location from "../../assets/location.svg";
import home from "../../assets/HomeIcon.svg";
import expired from "../../assets/expired.svg";
import { dimensionsCalculation, getStorageValue, setStorageValue, formatDate, copyPackageDetails, compareDate } from "../../utils/helper";
import star from "../../assets/star.svg";
import packageDelivery from "../../assets/pdelivery.svg";
import statusIcon from "../../assets/statusicon.svg";
import mapIcon from "../../assets/map.svg";
import delivered from "../../assets/delivered.svg";
import assigned from "../../assets/assigned.svg";
import intransit from "../../assets/intransit.svg";
import emptyveh from "../../assets/emptyvehicle.svg";
import vehicle from "../../assets/avehicle.svg";
import deliveredveh from "../../assets/dvehicle.svg";
import AlertMessage from "../common/AlertMessage";
import { ReactComponent as DeliveryPerson } from "../../assets/logos/delivery_person_icon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ViewMap from "../common/ViewMap";
import "../../styles/ViewMap.css";
import Loaders from "../common/Loaders";
import { statusMapping, initialMapping, secondMapping, thirdMapping, mapHeight} from "../../data/PackageListing";
import { BasicLayout } from "../../layouts/BasicLayout";
import NotificationsListAPI from "../../utils/services/notifications.api";

const PackageDetails = () => {
  const { packagePin } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [packageDetails, setPackageDetails] = useState(null);
  const [viewingMapPage, setViewingMapPage] = useState(false);
  const [status, setStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    message: "",
    severity: "",
  });
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [review, setReview] = useState("");
  const [rating, setRating] = useState(0);
  const [isShowNotifications, setShowNotifications] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI
  const [ratingError, setRatingError] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showActions, setShowActions] = useState(true);

  const myRef = useRef(null);
  myRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  const clearingUpdatePhase = async (event) => {
    setStorageValue("updatePhase","");
  };

  const handleBack = () => {
    if (state?.tab && state?.originPage) {
      if (state?.originPage === "MyRequest") {
        setTimeout(() => {
          setStorageValue("menuName", "My Request");
          navigate("/MyRequest", {
            state: { status: state?.tab },
          });
          clearingUpdatePhase();
        }, 2000);
      } else if (state?.originPage === "MyDelivery") {
          setTimeout(() => {
            setStorageValue("menuName", "My Delivery");
            navigate("/MyDelivery", {
              state: { status: state?.tab },
            });
            clearingUpdatePhase();
          }, 2000);
      } else {
        setTimeout(() => {
          setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
          navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
          clearingUpdatePhase();
        }, 2000);
      }
    } else if (state?.backURL) {
      if(state?.backURL?.includes("/users")){
        setStorageValue("menuName", "Users");
      } else if(state?.backURL?.includes("/notifications")) {
        setStorageValue("menuName", "Notifications");
      }
      setTimeout(() => {
        navigate(state?.backURL, {
          state: {
            tab: state?.tab,
            statusId:
              selectedStatus === "Intransit"
                ? "In-Transit"
                : selectedStatus === "" ? state?.statusId : selectedStatus,
            userData: state?.userData,
          },
        });
        clearingUpdatePhase();
      }, 2000);
    } else {
      setTimeout(() => {
        setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
        navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
        clearingUpdatePhase();
      }, 2000);
    }
  }

  const handleDeleteConfirmation = async () => {
    if(alertMessage.severity === "success"){
      return;
    }
    if (!packageDetails) {
      setAlertMessage({
        message: "The job has already been deleted.",
        severity: "error",
      });
      setOpen(true);
      return;
    }

    try {
      const response = await PackageListings.getPackageDetailsbyId(
        packageDetails.id
      );

      if (response.status !== "success" || !response.data) {
        setAlertMessage({
          message: "The job has already been deleted.",
          severity: "error",
        });
        setOpen(true);
        handleBack();
        return;
      }

      if (response.data.status !== 1 && response.data.status !== 5) {
        setAlertMessage({
          message: `Job is moved to ${
            statusMapping[response.data.status]
          } status`,
          severity: "error",
        });
        setOpen(true);
        return;
      }

      setDeleteModalOpen(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setAlertMessage({
          message: "The job has already been deleted.",
          severity: "error",
        });

        setOpen(true);
        handleBack();
      }
    }
  };

  const handleViewMap = () => {
    if (alertMessage?.severity && alertMessage?.severity === "error") {
      setAlertMessage({
        message: alertMessage?.message,
        severity: "error",
      });
      setOpen(true);
    } else {
      setViewingMapPage(!viewingMapPage);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setShowActions(true);
  };

  const handleJobDeleteConfirm = async () => {
    setDeleteModalOpen(false);
    setShowActions(false);
    if (!packageDetails?.id) {
      setAlertMessage({ message: "Invalid package ID", severity: "error" });
      setOpen(true);
      setShowActions(true);
      return;
    }

    setLoading(true);

    try {
      const userId = parseInt(getStorageValue("userId"));
      const result = await PackageListings.DeleteJobById(
        packageDetails.id,
        userId
      );

      if (result.status === "success") {
        setAlertMessage({
          message: "Job Deleted Successfully.",
          severity: "success",
        });
        setOpen(true);
        setStorageValue("updatePhase","Updated");
        handleBack();
      } else {
        setAlertMessage({
          message: result.message || "Failed to delete job",
          severity: "error",
        });
        setOpen(true);
        setShowActions(true);
      }
    } catch (error) {
      setAlertMessage({
        message: `Error: ${error.message}`,
        severity: "error",
      });
      setOpen(true);
      setShowActions(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      const checkDate = new Date()?.toISOString();
        const response = await checkUnreadNotifications(getStorageValue("userId"), checkDate);
        if(response?.data?.message) {
          localStorage.removeItem("isClicked");
          localStorage.setItem("isReload", response?.data?.message);
          localStorage.setItem("notifications", response?.data?.message);
          setShowNotifications(response?.data?.message);
        }
    } 
  };

  useEffect(() => {
    fetchPackageDetails();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  const fetchPackageDetails = async () => {
    setLoading(true);
    try {
      const response = await PackageListings.getPackageDetailsbyId(packagePin);
      if (response.status === "success") {
        setPackageDetails(response.data);
      } else {
        if (response?.error?.status === 404) {
          setAlertMessage({
            message: "This package has been deleted and is no longer available",
            severity: "error",
          });
        } else {
          setAlertMessage({
            message: "Failed to fetch job details",
            severity: "error",
          });
        }
        setOpen(true);
      }
    } catch (error) {
      setAlertMessage({
        message: error || "Failed to fetch package details",
        severity: "error",
      });
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handlenavigateBack = () => {
    if (selectedStatus) {
      setStorageValue("menuName", "Admin");
      navigate("/dashboard", {
        state: {
          status: parseInt(
            Object.keys(statusMapping).find(
              (key) => statusMapping[key] === selectedStatus
            )
          ),
        },
      });
    } else if (state?.backURL) {
      if(state?.backURL?.includes("/users")){
        setStorageValue("menuName", "Users");
      } else if(state?.backURL?.includes("/notifications")) {
        setStorageValue("menuName", "Notifications");
      }
      navigate(state?.backURL, {
        state: {
          tab: state?.tab,
          statusId: state?.statusId,
          userData: state?.userData,
        },
      });
    } else if (state?.tab && !state?.originPage) {
      setStorageValue("menuName", "Admin");
      navigate("/dashboard", { state: { status: state?.tab } });
    } else if (
      state?.tab &&
      state?.originPage &&
      state?.originPage === "MyRequest"
    ) {
      setStorageValue("menuName", "My Request");
      navigate("/MyRequest", { state: { status: state?.tab } });
    } else if (
      state?.tab &&
      state?.originPage &&
      state?.originPage === "MyDelivery"
    ) {
      setStorageValue("menuName", "My Delivery");
      navigate("/MyDelivery", { state: { status: state?.tab } });
    } else if (Number(state?.tab) === 0) {
      setStorageValue("menuName", "Admin");
      navigate("/dashboard", { state: { status: state?.tab } });
    } else {
      setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
      navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
    }
  };

  useEffect(() => {
    if (packageDetails?.status) {
      setStatus(statusMapping[packageDetails.status]);
      setViewingMapPage(true);
    }
  }, [packageDetails]);

  const handleChange = async (event) => {
    setSelectedStatus(event.target.value);
    setModalOpen(true);
  };

  const handleStatusMapping = () => {
    if (
      state?.originPage !== "MyRequest" &&
      status &&
      Number(getStorageValue("roleId")) !== 1
    ) {
      if (status === "Unassigned") {
        return Object.entries(initialMapping);
      } else if (status === "Assigned") {
        return Object.entries(secondMapping);
      } else if (status === "Intransit") {
        return Object.entries(thirdMapping);
      } else {
        return Object.entries(statusMapping);
      }
    } else {
      return Object.entries(statusMapping);
    }
  };

  const handleConfirmChange = async () => {
    if (
      selectedStatus === "Delivered" &&
      rating === 0 &&
      packageDetails?.requestedBy !== packageDetails?.acceptedBy &&
      (Number(packageDetails?.status) === 2 || Number(packageDetails?.status) === 3) &&
      packageDetails?.acceptedBy !== parseInt(getStorageValue("userId"))
    ) {
      setModalOpen(false);
      setReviewModalOpen(true);
      return;
    }
    setModalOpen(false);
    setLoading(true);

    try {
      const response = await PackageListings.getPackageDetailsbyId(
        packageDetails?.id
      );
      if (response.status === "success" && response.data?.status) {
        const latestStatus = statusMapping[response.data.status];
        if (latestStatus !== status) {
          setAlertMessage({
            message: `Job is already in ${latestStatus.toLowerCase()} status.`,
            severity: "error",
          });
          setOpen(true);
          setStatus(latestStatus);
          setPackageDetails((prevDetails) => ({
            ...prevDetails,
            status: response.data.status,
          }));
          return;
        }
      }

      const payload = {
        jobId: packageDetails?.id,
        roleId: parseInt(getStorageValue("roleId")),
        userId: parseInt(getStorageValue("userId")),
        statusId: state?.originPage !== "MyRequest" &&
        Number(packageDetails?.status) === 3 &&
        Number(getStorageValue("roleId")) !== 1 ? 6 : parseInt(
          Object.keys(statusMapping).find(
            (key) => statusMapping[key] === selectedStatus
          )
        ),
        ratingValue: 0,
        description: "",
      };

      const result = await PackageListings.putPackageStatusById(payload);

      if (result.status === "success") {
        fetchPackageDetails();
        setAlertMessage({
          message: result.data.message,
          severity: "success",
        });
        setOpen(true);
        setStatus(selectedStatus ? selectedStatus : status);
        setStorageValue("updatePhase","Updated");

        const statusTabMapping = {
          Unassigned: { page: "/dashboard", tab: 1 },
          Assigned: { page: "/dashboard", tab: 2 },
          Intransit: { page: "/dashboard", tab: 3 },
          Delivered: { page: "/dashboard", tab: 4 },
        };
        const target = statusTabMapping[selectedStatus ? selectedStatus : status] || {
          page: "/dashboard",
          tab: 1,
        };
        if (status !== "Delivered" && state?.tab && state?.originPage) {
          if (state?.originPage === "MyRequest") {
            setTimeout(() => {
              navigate("/MyRequest", {
                state: { status: target.tab },
              });
              clearingUpdatePhase();
            }, 2000);
          } else if (state?.originPage === "MyDelivery") {
            if (Number(target.tab) === 1 && getStorageValue("roleId") !== "1") {
              setTimeout(() => {
                navigate("/MyDelivery", {
                  state: { status: target.tab },
                });
                clearingUpdatePhase();
              }, 2000);
            } else if (Number(target.tab) === 1) {
              setTimeout(() => {
                localStorage.setItem("menuName", "Admin");
                navigate(target.page, { state: { status: target.tab } });
                clearingUpdatePhase();
              }, 2000);
            } else {
              setTimeout(() => {
                navigate("/MyDelivery", {
                  state: { status: target.tab },
                });
                clearingUpdatePhase();
              }, 2000);
            }
          } else {
            localStorage.setItem("menuName", "Admin");
            setTimeout(() => {
              navigate(target.page, { state: { status: target.tab } });
              clearingUpdatePhase();
            }, 2000);
          }
        } else if (status !== "Delivered" && state?.backURL) {
          setTimeout(() => {
            navigate(state?.backURL, {
              state: {
                tab: state?.tab,
                statusId:
                  selectedStatus === "Intransit"
                    ? "In-Transit"
                    : selectedStatus,
                userData: state?.userData,
              },
            });
            clearingUpdatePhase();
          }, 2000);
        } else {
          localStorage.setItem("menuName", "Admin");
          setTimeout(() => {
            navigate(target.page, { state: { status: target.tab } });
            clearingUpdatePhase();
          }, 2000);
        }
      } else {
        if (result?.error?.status === 404) {
          setAlertMessage({
            message: "The job has already been deleted.",
            severity: "error",
          });
          setOpen(true);
          handleBack();
        } else {
          setAlertMessage({
            message: result.message || "Failed to update job status",
            severity: "error",
          });
          setOpen(true);
        }    
      }
    } catch (error) {
      setAlertMessage({
        message: `Error: ${error.message}`,
        severity: "error",
      });
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitReview = async () => {
    if (
      selectedStatus === "Delivered" &&
      rating === 0 &&
      packageDetails?.requestedBy !== packageDetails?.acceptedBy &&
      (Number(packageDetails?.status) === 2 || Number(packageDetails?.status) === 3) &&
      packageDetails?.acceptedBy !== parseInt(getStorageValue("userId"))
    ) {
      setRatingError(true);
      return;
    }

    setReviewModalOpen(false);
    setLoading(true);

    const payload = {
      jobId: packageDetails?.id,
      roleId: parseInt(getStorageValue("roleId")),
      userId: parseInt(getStorageValue("userId")),
      statusId: parseInt(
        Object.keys(statusMapping).find(
          (key) => statusMapping[key] === selectedStatus
        )
      ),
      ratingValue: rating,
      description: review,
    };

    try {
      const result = await PackageListings.putPackageStatusById(payload);

      if (result.status === "success") {
        fetchPackageDetails();
        setAlertMessage({
          message: "Review submitted and status updated successfully",
          severity: "success",
        });
        setOpen(true);

        setPackageDetails((prevDetails) => ({
          ...prevDetails,
          rating: rating,
          ratingDescription: review,
          status: selectedStatus,
        }));
        setStorageValue("updatePhase","Updated");

        setStatus(selectedStatus);
        const statusTabMapping = {
          Unassigned: { page: "/dashboard", tab: 1 },
          Assigned: { page: "/dashboard", tab: 2 },
          Intransit: { page: "/dashboard", tab: 3 },
          Delivered: { page: "/dashboard", tab: 4 },
        };
        const target = statusTabMapping[selectedStatus] || {
          page: "/dashboard",
          tab: 4,
        };
        if (status !== "Delivered" && state?.tab && state?.originPage) {
          if (state?.originPage === "MyRequest") {
            setTimeout(() => {
              navigate("/MyRequest", {
                state: { status: target.tab },
              });
              clearingUpdatePhase();
            }, 2000);
          } else if (state?.originPage === "MyDelivery") {
            setTimeout(() => {
              navigate("/MyDelivery", {
                state: { status: target.tab },
              });
              clearingUpdatePhase();
            }, 2000);
          } else {
            setTimeout(() => {
              navigate(target.page, { state: { status: target.tab } });
              clearingUpdatePhase();
            }, 2000);
          }
        } else if (status !== "Delivered" && state?.backURL) {
          setTimeout(() => {
            navigate(state?.backURL, {
              state: {
                tab: state?.tab,
                statusId:
                  selectedStatus === "Intransit"
                    ? "In-Transit"
                    : selectedStatus,
                userData: state?.userData,
              },
            });
            clearingUpdatePhase();
          }, 2000);
        } else {
          setTimeout(() => {
            navigate(target.page, { state: { status: target.tab } });
            clearingUpdatePhase();
          }, 2000);
        }
      } else {
        setAlertMessage({
          message:
            result.message || "Failed to submit review and update status",
          severity: "error",
        });
        setOpen(true);
      }
    } catch (error) {
      setAlertMessage({
        message: `Error: ${error.message}`,
        severity: "error",
      });
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSelectedStatus("");
    setModalOpen(false);
  };

  useEffect(() => {
    if (status) {
      setPackageDetails((prevDetails) => ({
        ...prevDetails,
        status: Object.keys(statusMapping).find(
          (key) => statusMapping[key] === status
        ),
      }));
    }
  }, [status]);

  const handleSnackbarClose = () => {
    setCopySuccess(false);
  };

  const handleSnackbarOpen = () => {
    setCopySuccess(true);
  };

  const handleConfirmDelivery = () => {
    setModalOpen(true);
  }

  return (
    <BasicLayout isShowNotifications={isShowNotifications}>
      <Box sx={{ position: "relative", minHeight: "100vh" }} ref={myRef}>
        {loading && <Loaders />}
        <Grid2
          sx={{
            width: viewingMapPage ? "63%" : "100%",
          }}
        >
          {
            <>
              <Button
                sx={{ 
                  color: "#2579CD", 
                  textTransform: "none", 
                  px: "0",
                  "&:disabled": {
                    color: "#2579CD"
                  }
                }}
                variant="none"
                size="medium"
                startIcon={<ArrowBackIcon />}
                onClick={handlenavigateBack}
                disabled={alertMessage.severity === "success"}
              >
                Back
              </Button>
              <Grid2 elevation={3} sx={{ paddingTop: "12px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {packageDetails?.title}
                    </Typography>
                    <Typography variant="body1" color="primary">
                      #{packageDetails?.id}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    {(Number(packageDetails?.status) === 1 ||
                      Number(packageDetails?.status) === 5) && (
                      <>
                        {" "}
                        {/* eslint-disable-next-line */}
                        {packageDetails?.status != 5 && (
                          <>
                            {showActions && 
                            (Number(getStorageValue("roleId")) === 1 || 
                            Number(getStorageValue("userId")) === Number(packageDetails?.requestedBy)) && (
                              <Typography
                                sx={{
                                  border: "1px solid #D5D7DA",
                                  borderRadius: "10px",
                                  paddingRight: !viewingMapPage ? "15px" : "",
                                  maxWidth: "120px",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if(alertMessage.severity === "success"){
                                    return;
                                  }
                                  copyPackageDetails(packageDetails, handleSnackbarOpen)
                                }}
                              >
                                <IconButton>
                                  <img src={copy} alt="copy" />
                                </IconButton>
                                {!viewingMapPage ? "Copy" : ""}
                              </Typography>
                            )}
                          </>
                        )}
                        <Snackbar
                          open={copySuccess}
                          disableWindowBlurListener
                          autoHideDuration={1000}
                          onClose={handleSnackbarClose}
                          message="Package details copied to clipboard!"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                        />
                        {showActions &&
                          (Number(getStorageValue("roleId")) === 1 || 
                          Number(getStorageValue("userId")) === Number(packageDetails?.requestedBy)) && (
                            <Typography
                              sx={{
                                border: "1px solid #D5D7DA",
                                borderRadius: "10px",
                                paddingRight: !viewingMapPage ? "15px" : "",
                                maxWidth: "120px",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                cursor: "pointer",
                              }}
                              onClick={handleDeleteConfirmation}
                            >
                              <IconButton>
                                <img src={deleteIcon} alt="delete" />
                              </IconButton>
                              {!viewingMapPage ? "Delete" : ""}
                            </Typography>
                          )}
                        <Modal
                          open={deleteModalOpen}
                          onClose={handleDeleteCancel}
                          aria-labelledby="confirm-modal-title"
                          aria-describedby="confirm-modal-description"
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "white",
                              padding: "16px",
                              borderRadius: 2,
                              width: "300px",
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{
                                backgroundColor: "#0C68F40F",
                                borderRadius: "50%",
                                textAlign: "center",
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "150px",
                                height: "150px",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                style={{
                                  width: "40%",
                                  height: "40%",
                                  objectFit: "cover",
                                }}
                                src={deleteIcon}
                                alt="delete"
                              />
                            </Box>
                            <Box
                              sx={{
                                padding: "10px",
                                backgroundColor: "#ffffff",
                                textAlign: "center",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  marginBottom: "16px",
                                  color: "#000000",
                                }}
                              >
                                Delete Confirmation
                              </Typography>

                              <Typography
                                variant="body1"
                                sx={{ marginBottom: "24px", color: "#555555" }}
                              >
                                {`Do you want to Delete the Job ${packageDetails?.title} - #${packageDetails.id}`}
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "12px",
                                }}
                              >
                                <Button
                                  onClick={handleDeleteCancel}
                                  variant="outlined"
                                  sx={{
                                    flex: 1,
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={handleJobDeleteConfirm}
                                  sx={{
                                    flex: 1,
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    backgroundColor: "#007BFF",
                                    color: "#FFFFFF",
                                    "&:hover": { backgroundColor: "#0056b3" },
                                  }}
                                >
                                  Confirm
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Modal>
                        {showActions &&
                          (Number(getStorageValue("roleId")) === 1 || 
                          Number(getStorageValue("userId")) === Number(packageDetails?.requestedBy)) && (
                            <>
                              <Typography
                                sx={{
                                  border: "1px solid #D5D7DA",
                                  borderRadius: "10px",
                                  paddingRight: !viewingMapPage ? "15px" : "",
                                  maxWidth: "120px",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if(alertMessage.severity === "success"){
                                    return;
                                  }
                                  navigate(`/edit-package/${packageDetails?.id ? packageDetails?.id : packagePin}`, {
                                    state: {
                                      backNavigationURL: `/packagedetails/${packageDetails?.id ? packageDetails?.id : packagePin}`,
                                      backURL: state?.backURL,
                                      tab: state?.tab,
                                      statusId: state?.statusId,
                                      userData: state?.userData,
                                      originPage: state?.originPage,
                                    },
                                  });
                                }}
                              >
                                <IconButton>
                                  <img src={edit} alt="edit" />
                                </IconButton>
                                {!viewingMapPage && "Edit"}
                              </Typography>
                            </>
                          )}
                      </>
                    )}

                    {state?.originPage !== "MyRequest" &&
                      Number(packageDetails?.status) === 3 &&
                      Number(getStorageValue("roleId")) !== 1 && (
                        <Box>
                          <Button
                            style={{
                              textTransform: "none",
                              borderRadius: "8px",
                              padding: "4px 16px",
                            }}
                            variant="contained"
                            size="medium"
                            disabled={alertMessage?.message !== ""}
                            onClick={() => handleConfirmDelivery()}
                          >
                            Confirm Delivery
                          </Button>
                        </Box>
                      )}

                    <FormControl
                      size="small"
                      sx={{
                        width: 160,
                        backgroundColor: `${
                          Number(packageDetails?.status) === 4
                            ? "#27ae60"
                            : Number(packageDetails?.status) === 5
                            ? "#eb4747"
                            : state?.originPage !== "MyRequest" &&
                              Number(packageDetails?.status) === 3 &&
                              Number(getStorageValue("roleId")) !== 1
                            ? "#ECECEC"
                            : "#4E42FF"
                        }`,
                        border: "none",
                        borderRadius: "10px",
                        margin: 0,
                        color: Number(packageDetails?.status) === 4 && "#fff",
                      }}
                    >
                      <Select
                        value={Number(packageDetails?.status) === 5 ? "Expired" : status}
                        onChange={handleChange}
                        disabled={
                          Number(packageDetails?.status) === 4 ||
                          Number(packageDetails?.status) === 5 ||
                          (state?.originPage !== "MyRequest" &&
                            Number(packageDetails?.status) === 3 &&
                            Number(getStorageValue("roleId")) !== 1)
                        }
                        sx={{
                          border: "none",
                          color: "white",
                          fontSize: "13px",
                          borderRadius: "10px",
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor:
                              state?.originPage !== "MyRequest" &&
                              Number(packageDetails?.status) === 3 &&
                              Number(getStorageValue("roleId")) !== 1
                                ? "black"
                                : "white",
                          },
                        }}
                        renderValue={(selected) =>
                          modalOpen && selectedStatus
                            ? `Status: ${selectedStatus}`
                            : `Status:  ${
                                Number(packageDetails?.status) === 5 ? "Expired" : status
                              }`
                        }
                      >
                        {handleStatusMapping()
                          .filter(
                            ([key, value]) =>
                              !(status === "Intransit" && value === "Assigned")
                          )
                          .map(([key, value]) => (
                            <MenuItem
                              sx={{
                                color: Number(packageDetails?.status) === 4 && "white",
                                fontSize: "13px",
                              }}
                              key={key}
                              value={value}
                            >
                              {value}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {!viewingMapPage && (
                      <Typography
                        sx={{
                          border: "1px solid #D5D7DA",
                          borderRadius: "10px",
                          paddingRight: !viewingMapPage ? "15px" : "",
                          maxWidth: "120px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                        onClick={handleViewMap}
                      >
                        <IconButton>
                          <img src={mapIcon} alt="map" />
                        </IconButton>
                        Map
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Modal
                  open={modalOpen}
                  onClose={handleCloseModal}
                  aria-labelledby="confirm-modal-title"
                  aria-describedby="confirm-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "white",
                      padding: "32px 32px 12px",
                      borderRadius: 2,
                      width: "350px",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#0C68F40F",
                        borderRadius: "50%",
                        textAlign: "center",
                        marginLeft: "20%",
                        width: "60%",
                      }}
                    >
                      {" "}
                      {Number(packageDetails?.status) === 4 ? (
                        <img src={delivered} alt="delievred" />
                      ) : (
                        <img src={statusIcon} alt="popupIcon" />
                      )}
                    </Box>
                    <Box
                      sx={{
                        padding: "24px",
                        backgroundColor: "#ffffff",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          marginBottom: "16px",
                          color: "#000000",
                        }}
                      >
                        Confirmation Required
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{ marginBottom: "24px", color: "#555555" }}
                      >
                        {selectedStatus === statusMapping[4]
                          ? `Hurray! We are happy that your package #${packageDetails?.id} is delivered on time. Please confirm the receipt of your package and make sure the package you received is appropriate.`
                          : state?.originPage !== "MyRequest" &&
                          Number(packageDetails?.status) === 3 &&
                          Number(getStorageValue("roleId")) !== 1 ? `Please confirm that you delivered a package "${packageDetails?.title}"` : `The status of the package #${
                              packageDetails?.id
                            } is about to be updated to ${
                              selectedStatus ||
                              statusMapping[packageDetails?.status]
                            }. Please confirm to proceed.`}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Button
                          onClick={handleCloseModal}
                          variant="outlined"
                          sx={{
                            flex: 1,
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleConfirmChange}
                          sx={{
                            flex: 1,
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: "bold",
                            backgroundColor: "#007BFF",
                            color: "#FFFFFF",
                            "&:hover": { backgroundColor: "#0056b3" },
                          }}
                        >
                          Confirm
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Modal>
                <Modal
                  open={reviewModalOpen}
                  onClose={() => setReviewModalOpen(false)}
                  aria-labelledby="review-modal-title"
                  aria-describedby="review-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "white",
                      padding: 4,
                      borderRadius: 2,
                      width: "350px",
                    }}
                  >
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bolder",
                          marginBottom: "16px",
                          color: "#000000",
                        }}
                      >
                        Your feedback is important to us.
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ marginBottom: "16px", color: "#555555" }}
                      >
                        Please rate based on your delivery experience
                      </Typography>
                    </Box>
                    <Rating
                      sx={{ fontSize: "3.5rem" }}
                      name="rating"
                      size="large"
                      value={rating}
                      onChange={(event, newValue) => {
                        setRating(newValue);
                        setRatingError(false);
                      }}
                    />
                    {ratingError && (
                      <div style={{ color: "#d32f2f" }}>
                        Please provide a rating to complete your feedback
                      </div>
                    )}
                    <InputLabel
                      sx={{
                        marginTop: "1rem",
                        fontSize: "14px",
                        fontWeight: "bolder",
                      }}
                      htmlFor="reviewBox"
                    >
                      Write a review
                    </InputLabel>
                    <TextField
                      sx={{
                        width: "100%",
                        marginTop: "0.5rem",
                        borderRadius: "1rem",
                      }}
                      id="review"
                      multiline
                      rows={2}
                      slotProps={{ htmlInput: { maxLength: 250 } }}
                      placeholder="write here..."
                      value={review}
                      onChange={(e) => setReview(e.target.value)}
                    />
                    <Box
                      sx={{
                        marginTop: 2,
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "space-around",
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setReviewModalOpen(false);
                          setRating(0);
                          setReview("");
                          setRatingError(false);
                        }}
                        sx={{ textTransform: "none", width: "100%" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleSubmitReview}
                        sx={{ textTransform: "none", width: "100%" }}
                      >
                        Submit review
                      </Button>
                    </Box>
                  </Box>
                </Modal>
                <Divider sx={{ my: 3 }} />
                <Grid2
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    paddingBottom: "15px",
                  }}
                  container
                  spacing={1}
                  mt={1}
                >
                  <Grid2
                    sx={{
                      border: "1px solid #D5D7DA",
                      borderRadius: "10px",
                      flex: "1 1 calc(25% - 5px)",
                      minWidth: "200px",
                      padding: "10px",
                    }}
                    item
                    xs={2}
                  >
                    <Typography variant="subtitle2" color="textSecondary">
                      Dimensions (in inches)
                    </Typography>
                    <Typography sx={{ fontSize: "16px" }} variant="body2">
                      {dimensionsCalculation(packageDetails)}
                    </Typography>
                  </Grid2>
                  <Grid2
                    sx={{
                      border: "1px solid #D5D7DA",
                      borderRadius: "10px",
                      flex: "1 1 calc(25% - 10px)",
                      minWidth: "200px",
                      padding: "10px",
                    }}
                    item
                    xs={2}
                  >
                    <Typography variant="subtitle2" color="textSecondary">
                      Weight
                    </Typography>
                    <Typography sx={{ fontSize: "16px" }} variant="body2">
                      {packageDetails?.weight
                        ? packageDetails?.weight.toFixed(2) + " lbs"
                        : "-"}
                    </Typography>
                  </Grid2>
                  <Grid2
                    sx={{
                      border: "1px solid #D5D7DA",
                      borderRadius: "10px",
                      flex: "1 1 calc(25% - 10px)",
                      minWidth: "200px",
                      padding: "10px",
                    }}
                    item
                    xs={2}
                  >
                    <Typography variant="subtitle2" color="textSecondary">
                      Created on
                    </Typography>
                    <Typography sx={{ fontSize: "16px" }} variant="body2">
                      {formatDate(packageDetails?.createdAt)}
                    </Typography>
                  </Grid2>
                  <Grid2
                    sx={{
                      border: "1px solid #D5D7DA",
                      borderRadius: "10px",
                      flex: "1 1 calc(25% - 10px)",
                      minWidth: "200px",
                      padding: "10px",
                    }}
                    item
                    xs={2}
                  >
                    <Typography variant="subtitle2" color="textSecondary">
                      Expiring On <img src={expired} alt="expired" />
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: compareDate(packageDetails?.expiresAt) && "red", fontSize: "16px" }}
                    >
                      {formatDate(packageDetails?.expiresAt)}
                    </Typography>
                  </Grid2>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    minWidth: "100%",
                  }}
                >
                  <Grid2 item xs={6} sx={{ width: "33.33%" }}>
                    <Typography
                      color="#0C68F4"
                      variant="subtitle1"
                      sx={{ fontWeight: "bold" }}
                    >
                      <img src={sender} alt="sender" /> Sender
                    </Typography>
                    <Typography
                      color="#101828"
                      variant="body2"
                      sx={{
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontWeight: "bold",
                      }}
                    >
                      {packageDetails?.source?.contactName}
                    </Typography>
                    <Typography variant="body2">
                      {`${packageDetails?.source?.countryCode}  ${packageDetails?.source?.contactNumber}`}
                    </Typography>
                  </Grid2>
                  <Grid2
                    item
                    xs={6}
                    sx={{
                      width: "fit-content",
                      maxWidth: "33.33%",
                    }}
                  >
                    <Typography
                      color="#0C68F4"
                      variant="subtitle1"
                      sx={{ fontWeight: "bold" }}
                    >
                      <img src={receiver} alt="sender" /> Receiver
                    </Typography>
                    <Typography
                      color="#101828"
                      variant="body2"
                      sx={{
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontWeight: "bold",
                      }}
                    >
                      {packageDetails?.destination?.contactName}
                    </Typography>
                    <Typography variant="body2">{`${packageDetails?.destination?.countryCode}  ${packageDetails?.destination?.contactNumber}`}</Typography>
                  </Grid2>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 1,
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <img src={location} alt="location" />
                    <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
                      Unassigned
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    {Number(packageDetails?.status) === 1 && (
                      <img
                        src={emptyveh}
                        alt="emp-veh"
                        style={{
                          position: "absolute",
                          top: "-24px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "transparent",
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        height: "2px",
                        width: "100%",
                        borderBottom: "2px dashed #000",
                      }}
                    ></Box>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <img src={assigned} alt="assigned" />
                    <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
                      Assigned
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    {(Number(packageDetails?.status) === 2 ||
                      Number(packageDetails?.status) === 3) && (
                      <img
                        src={vehicle}
                        alt="vehicle"
                        style={{
                          position: "absolute",
                          top: "-32px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "transparent",
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        height: "2px",
                        width: "100%",
                        borderBottom: "2px dashed #000",
                      }}
                    ></Box>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <img src={intransit} alt="intransit" />
                    <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
                      Intransit
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    {Number(packageDetails?.status) === 4 && (
                      <img
                        src={deliveredveh}
                        alt="del-veh"
                        style={{
                          position: "absolute",
                          top: "-32px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "transparent",
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        height: "2px",
                        width: "100%",
                        borderBottom: "2px dashed #000",
                      }}
                    ></Box>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <img src={home} alt="home" />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Delivered
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Grid2
                    sx={{
                      flex: "1 1 45%",
                      minWidth: "20%",
                      maxWidth: "33.33%",
                      wordWrap: "break-word",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      color="#101828"
                      sx={{ fontWeight: "bold", marginTop: 1 }}
                    >
                      Pickup Location
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        marginTop: 0.5,
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {packageDetails?.source?.addressLine} <br />
                      {`${packageDetails?.source?.city},${packageDetails?.source?.state}  ${packageDetails?.source?.zipCode}`}
                    </Typography>
                  </Grid2>
                  <Grid2
                    sx={{
                      flex: "1 1 45%",
                      minWidth: "20%",
                      maxWidth: "33.33%",
                      wordWrap: "break-word",
                      textAlign: "right",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      color="#101828"
                      sx={{ fontWeight: "bold", marginTop: 1 }}
                    >
                      Delivery Location
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        marginTop: 0.5,
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {packageDetails?.destination?.addressLine} <br />
                      {`${packageDetails?.destination?.city},${packageDetails?.destination?.state}  ${packageDetails?.destination?.zipCode}`}
                    </Typography>
                  </Grid2>
                </Grid2>
                <Divider sx={{ my: 3 }} />
                <Box>
                  <Typography
                    variant="subtitle1"
                    color="#101828"
                    sx={{ fontWeight: "bold" }}
                  >
                    Description
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {packageDetails?.description || ""}
                  </Typography>
                </Box>
                {packageDetails?.specialInstruction && (
                  <Box mt={3}>
                    <Typography
                      color="#101828"
                      variant="subtitle1"
                      sx={{ fontWeight: "bold" }}
                    >
                      Special Instructions
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {packageDetails?.specialInstruction || ""}
                    </Typography>
                  </Box>
                )}
                {packageDetails?.deliveryPerson && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <Typography
                      color="#101828"
                      variant="subtitle1"
                      sx={{ paddingBottom: "5px", fontWeight: "bold" }}
                    >
                      Delivery Person Details
                    </Typography>
                    <Grid2
                      sx={{
                        border: "1px solid #E4E7EC",
                        borderRadius: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#FFFFFF",
                          padding: "16px",
                          borderRadius: "8px",
                          margin: "auto",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <DeliveryPerson
                            width={40}
                            height={40}
                            style={{ marginRight: "8px" }}
                          />
                          <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography
                              sx={{ color: "#2A3C57", fontWeight: 700 }}
                            >
                              {`${
                                packageDetails?.deliveryPerson?.firstName || "-"
                              } ${
                                packageDetails?.deliveryPerson?.lastName || "-"
                              }`}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#2A3C57",
                                fontWeight: 500,
                                wordBreak: "break-word",
                              }}
                            >
                              {`${
                                packageDetails?.deliveryPerson?.countryCode || "-"
                              } ${
                                packageDetails?.deliveryPerson?.contactNumber ||
                                "-"
                              }`}{" "}
                              <br />
                              {packageDetails?.deliveryPerson?.addressLine || ""}
                              <br />
                              {`${packageDetails?.deliveryPerson?.city || ""} ${
                                packageDetails?.deliveryPerson?.state || ""
                              } ${packageDetails?.deliveryPerson?.zipCode || ""}`}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: "flex", gap: "16px" }}>
                          <Box
                            sx={{
                              backgroundColor: "#F3F9FF",
                              padding: "8px 16px",
                              borderRadius: "8px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#0066CC",
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              <img src={packageDelivery} alt="package delivery" />{" "}
                              {packageDetails?.deliveryPerson?.packageDelivered}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#000000",
                                fontSize: "12px",
                                fontWeight: 500,
                              }}
                            >
                              Packages Delivered
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#FFF8E5",
                              padding: "8px 16px",
                              borderRadius: "8px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#FFAB00",
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              <img src={star} alt="star" />{" "}
                              {packageDetails?.deliveryPerson?.rating}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#000000",
                                fontSize: "12px",
                                fontWeight: 500,
                              }}
                            >
                              Overall Rating
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      {Number(packageDetails?.status) === 4 && packageDetails?.rating && (
                        <>
                          <Divider
                            sx={{
                              marginBottom: "16px",
                              width: "95%",
                              marginLeft: "2.5%",
                            }}
                          />
                          <Box
                            sx={{
                              backgroundColor: "#FFFFFF",
                              paddingLeft: "16px",
                              borderRadius: "8px",
                              margin: "auto",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#333333",
                                marginBottom: "8px",
                                fontWeight: "700",
                              }}
                            >
                              Your Package Rating
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "16px",
                              }}
                            >
                              <Rating
                                value={packageDetails?.rating}
                                precision={0.5}
                                readOnly
                              />
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  paddingLeft: "8px",
                                  fontSize: "18px",
                                }}
                              >
                                {packageDetails?.rating
                                  ? packageDetails?.rating + "/5"
                                  : ""}
                              </Typography>
                            </Box>
                            {packageDetails?.ratingDescription && (
                              <>
                                <Typography sx={{ fontWeight: "700" }}>
                                  Comments
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    color: "#333333",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    ordBreak: "break-word",
                                    whiteSpace: "normal",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {packageDetails?.ratingDescription
                                    ? packageDetails?.ratingDescription
                                    : ""}
                                </Typography>
                              </>
                            )}
                          </Box>
                        </>
                      )}
                    </Grid2>
                  </>
                )}
              </Grid2>
              {viewingMapPage && (
                <ViewMap
                  mapDetails={[
                    {
                      lat: packageDetails?.source?.latitude,
                      lng: packageDetails?.source?.longitude,
                      address:
                        packageDetails?.source?.addressLine +
                        " , " +
                        packageDetails?.source?.city +
                        " , " +
                        packageDetails?.source?.state +
                        " , " +
                        packageDetails?.source?.zipCode,
                    },
                    {
                      lat: packageDetails?.destination?.latitude,
                      lng: packageDetails?.destination?.longitude,
                      address:
                        packageDetails?.destination?.addressLine +
                        " , " +
                        packageDetails?.destination?.city +
                        " , " +
                        packageDetails?.destination?.state +
                        " , " +
                        packageDetails?.destination?.zipCode,
                    },
                  ]}
                  handleViewMap={handleViewMap}
                  heightValue={status ? mapHeight[status] : "100vh"}
                />
              )}
              <AlertMessage
                open={open}
                handleClose={handleClose}
                message={alertMessage.message}
                severity={alertMessage.severity}
              />
            </>
          }
        </Grid2>
      </Box>
    </BasicLayout>
  );
};

export default PackageDetails;
